import React, {useEffect} from 'react';
import {connect} from "react-redux";
import '../../App.css';
import App from "./App";
import {loadPurchase} from "../../redux/formReducer";

type Props = {
    loadPurchase: (id: string, hash: string) => void;
    purchaseId: string;
    error: boolean;
}
const AppContainer: React.FC<Props> = ({loadPurchase, error, purchaseId}) => {

    useEffect(() => {
        document.title = "Альфа-Тендеры: Сервис подачи конкурсных предложений ЗАО «Альфа-Банк»";
        let purchaseId: string = window.location.pathname;
        let hash: string = window.location.hash.split('?').shift() || window.location.hash;
        loadPurchase(purchaseId, hash);
    }, [loadPurchase]);


    return (
        <>
            {(purchaseId || error) ? <App/> : null}
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        purchaseId: state.form.data.purchaseId,
        error: state.form.error
    }
};

export default connect(mapStateToProps, {loadPurchase})(AppContainer);